// src/services/locales/consumo.js

// Generador de datos para intervalos de 15 minutos
const generarDatosTendencia = () => {
  const datos = [];
  let hora = new Date();
  hora.setHours(0, 0, 0, 0);

  for (let i = 0; i < 96; i++) {
    const timeString = hora.toLocaleTimeString("es-CL", { hour: "2-digit", minute: "2-digit" });

    // Simulación de mayor consumo durante el día laboral (8:00 a 20:00)
    const factorHora = hora.getHours() >= 8 && hora.getHours() <= 20 ? 1.5 : 0.6;

    datos.push({
      tiempo: timeString,
      potenciaTotal: +(Math.random() * 5 + 15 * factorHora).toFixed(2),
      potenciaHVAC1: +(Math.random() * 2 + 5 * factorHora).toFixed(2),
      potenciaHVAC2: +(Math.random() * 2 + 6 * factorHora).toFixed(2),
      tempInterior: +(Math.random() * 2 + 20).toFixed(1),
      tempExterior: +(Math.random() * 8 + 12 + factorHora * 5).toFixed(1),
    });

    hora.setMinutes(hora.getMinutes() + 15);
  }
  return datos;
};

const ConsumoService = {
  async obtenerMetricasGenerales(localId) {
    console.log(`Obteniendo métricas generales para local ${localId}...`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          consumoTotalEnergia: "4.034,2",
          consumoPersonalizado: "804,5",
          peakDemanda: "84,2",
        });
      }, 400);
    });
  },

  async obtenerTendenciaEnergia(localId, fecha = null) {
    console.log(`Obteniendo tendencia de energía para local ${localId} en fecha ${fecha}...`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(generarDatosTendencia());
      }, 600);
    });
  },

  async obtenerConsumoAnual(localId, anio = null) {
    console.log(`Obteniendo consumo anual para local ${localId} en año ${anio}...`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          { mes: "Ene", consumo: 4500 },
          { mes: "Feb", consumo: 4800 },
          { mes: "Mar", consumo: 4200 },
          { mes: "Abr", consumo: 3800 },
          { mes: "May", consumo: 3500 },
          { mes: "Jun", consumo: 3900 },
          { mes: "Jul", consumo: 4100 },
          { mes: "Ago", consumo: 4300 },
          { mes: "Sep", consumo: 3800 },
          { mes: "Oct", consumo: 3900 },
          { mes: "Nov", consumo: 4200 },
          { mes: "Dic", consumo: 4600 },
        ]);
      }, 500);
    });
  },
};

export default ConsumoService;
